/** Browser navigation helpers for the backend-owned SAML redirect flow. */
export const beginSamlLogin = (returnTo: string): void => {
  const normalized = returnTo.startsWith('/') && !returnTo.startsWith('//')
    ? returnTo
    : '/dashboard';
  window.location.assign(`/api/auth/saml/login?returnTo=${encodeURIComponent(normalized)}`);
};
